import { render, staticRenderFns } from "./DecisionImport.vue?vue&type=template&id=30875880&scoped=true&"
import script from "./DecisionImport.vue?vue&type=script&lang=ts&"
export * from "./DecisionImport.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionImport.vue?vue&type=style&index=0&id=30875880&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30875880",
  null
  
)

export default component.exports